import React, { useCallback } from "react";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import t from "module/translations";
import TableHeadRow from "component/table/tableHeadRow/TableHeadRow";
import TableHead from "@mui/material/TableHead";
import TableSortCellContainer from "module/sort/enrichedComponent/TableSortCellContainer";
import { InventoryCheckSortProperty } from "pages/inventoryCheckList/types";

interface Props {
  toggleAll: (checked: boolean) => void;
  areAllSelected: boolean;
  isAnySelected: boolean;
  hasPermissionToDownload: boolean;
}

const InventoryCheckListTableHead: React.FC<Props> = ({
  toggleAll,
  areAllSelected,
  isAnySelected,
  hasPermissionToDownload,
}) => {
  const handleToggleAll = useCallback(
    (event: { target: { checked: boolean } }) =>
      toggleAll(event.target.checked),
    [toggleAll]
  );

  return (
    <TableHead>
      <TableHeadRow>
        {hasPermissionToDownload && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={isAnySelected}
              checked={areAllSelected}
              onChange={handleToggleAll}
            />
          </TableCell>
        )}
        <TableCell align="left">
          {t.inventoryCheck.reportingNumberText}
        </TableCell>
        <TableCell align="left">{t.inventoryCheck.subjectText}</TableCell>
        <TableCell align="left">{t.inventoryCheck.assigneeText}</TableCell>
        <TableSortCellContainer
          {...{
            fieldName: InventoryCheckSortProperty.createdAt,
          }}
        >
          {t.inventoryCheck.createdAtText}
        </TableSortCellContainer>
      </TableHeadRow>
    </TableHead>
  );
};

export default InventoryCheckListTableHead;
